import React, { useEffect, useState } from 'react'
import Icon from '../../icon'
import globalData from '../../../common/globalData'
import './index.less'

// eslint-disable-next-line no-shadow
export enum FIRST_TOOLTIP_TYPE{
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

type TFIRST_TOOLTIP = {
  children: any,
  contentWidth?:number | string,
  keyValue:number | string,
  text: string,
  type?:FIRST_TOOLTIP_TYPE,
  onClose?:any,
  visible?:number,
  className?:string,
  onClick?:any,
}

export default ({
  children,
  text,
  contentWidth,
  keyValue,
  type = FIRST_TOOLTIP_TYPE.RIGHT,
  onClose,
  visible = 0,
  className,
  onClick,
}:TFIRST_TOOLTIP) => {
  const [_visible, setVisible] = useState(0)

  useEffect(() => {
    if (!keyValue) {
      setVisible(visible)
    }
  }, [visible])

  const _onClose = (e) => {
    e.stopPropagation()
    if (keyValue) {
      globalData.set(keyValue, 0)
    }
    setVisible(0)
    onClose?.()
  }

  const content = (<div className="MNfirstTooltipContent" style={{ width: contentWidth }}>
    {
      type === FIRST_TOOLTIP_TYPE.LEFT && <div className="MNfirstTooltipContentCloseLeft" onClick={_onClose}>
        <Icon type="m-guanbi" />
      </div>
    }
    {text}
    {
      type === FIRST_TOOLTIP_TYPE.RIGHT && <div className="MNfirstTooltipContentClose" onClick={_onClose}>
        <Icon type="m-guanbi" />
      </div>
    }
  </div>)

  useEffect(() => {
    if (keyValue) {
      globalData.get(keyValue, setVisible, 1)
    }
  }, [])
  return <div className={className} onClick={onClick}>
    {children}
    {
      !!_visible && <div className="replace-antd-MNfirstTooltip">{content}</div>
    }
  </div>
}
